import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, errMsg } from "@/lib/api";
import { RolePicker } from "@/components/RolePicker";

const EMPTY = { name: "", email: "", password: "", role: "kasir" };

export const UserFormDialog = ({ open, user, onClose, onSaved }) => {
  const [form, setForm] = useState(EMPTY);
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) { setForm(user ? { name: user.name, email: user.email, password: "", role: user.role } : EMPTY); setError(""); }
  }, [open, user]);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (form.password && form.password.length < 8) return setError("Password minimal 8 karakter");
    setSaving(true);
    try {
      const role = form.role === "owner" ? undefined : form.role;
      if (user) await api.put(`/users/${user.id}`, { name: form.name, email: form.email, password: form.password || null, active: user.active, role });
      else await api.post("/users", form);
      toast.success(user ? "User diperbarui" : "User ditambahkan");
      onSaved();
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" aria-describedby={undefined} data-testid="user-form-dialog">
        <DialogTitle className="font-display">{user ? "Edit User" : "Tambah User"}</DialogTitle>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="user-name">Nama</Label>
            <Input id="user-name" required maxLength={60} value={form.name} onChange={set("name")} data-testid="user-form-name-input" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="user-email">Email</Label>
            <Input id="user-email" type="email" required value={form.email} onChange={set("email")} data-testid="user-form-email-input" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="user-password">{user ? "Password Baru (kosongkan jika tidak diubah)" : "Password"}</Label>
            <Input id="user-password" type="password" autoComplete="new-password" required={!user} value={form.password} onChange={set("password")} data-testid="user-form-password-input" />
          </div>
          {form.role !== "owner" && <RolePicker value={form.role} onChange={(role) => setForm((f) => ({ ...f, role }))} />}
          {error && <p className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-600" data-testid="user-form-error">{error}</p>}
          <div className="flex gap-2 pt-1">
            <Button type="button" variant="outline" className="flex-1" onClick={onClose} data-testid="user-form-cancel">Batal</Button>
            <Button type="submit" disabled={saving} className="flex-1 bg-emerald-600 hover:bg-emerald-700" data-testid="user-form-submit">Simpan</Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
